var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.171,
    height: 31.965,
    viewBox: "0 0 46.171 31.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.858-72.5H25.314A7.814,7.814,0,0,0,17.5-64.686v16.338a7.814,7.814,0,0,0,7.814,7.814H55.858a7.814,7.814,0,0,0,7.814-7.814V-64.686A7.814,7.814,0,0,0,55.858-72.5ZM49.629-56.2,35.777-49.1a.358.358,0,0,1-.347-.011.354.354,0,0,1-.172-.3V-63.621a.354.354,0,0,1,.172-.3.359.359,0,0,1,.347-.011l13.851,7.1a.356.356,0,0,1,.194.316.356.356,0,0,1-.194.316Z",
    transform: "translate(-17.5 72.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShow);
export default __webpack_public_path__ + "static/media/icon-show.9d7ab5ce.svg";
export { ForwardRef as ReactComponent };